module.exports = __webpack_public_path__ + "static/media/robot.b34fc52c.png";